var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-cropper" }, [
    _c("div", { staticClass: "jp-cropper__img" }, [
      _c("img", { ref: "img", attrs: { src: _vm.src } }),
    ]),
    _c("div", { staticClass: "jp-cropper__preview" }, [
      _c("h4", [_vm._v("图像预览")]),
      _c("div", { ref: "preview", staticClass: "jp-cropper__preview__img" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }